import { LongText as LongTextComponent } from 'components/LongText';

import type { LongText as TLongText } from 'server/repository/hygraph/generated/graphqlTypes';

interface ILongText {
  templateProps: TLongText;
}

export const LongText = ({ templateProps }: ILongText) => <LongTextComponent {...templateProps} />;
